"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShortcutBase = /** @class */ (function () {
    function ShortcutBase(key, type, scenarioStatisticQuery) {
        this.key = key;
        this.type = type;
        this.scenarioStatisticQuery = scenarioStatisticQuery;
    }
    ShortcutBase.prototype.getRootOptions = function (shortcutOptions) {
        return {};
    };
    ShortcutBase.prototype.getDirectResponse = function (shortcutOptions, scenarioStatistics) {
        return undefined;
    };
    return ShortcutBase;
}());
exports.ShortcutBase = ShortcutBase;
//# sourceMappingURL=ShortcutBase.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/query/scenarioStatistics/shortcuts/ShortcutBase.js
// module id = 51
// module chunks = 1